<template>
  <div class="structured-wrapper container">
    <section class="structured-container">
      <slot><router-view /></slot>
    </section>
    <section class="sidebar" :class="sidebarClass">
      <slot name="sidebar"><router-view name="sidebar" /></slot>
    </section>
  </div>
</template>

<script>
export default {
  props: ['sidebarClass'],
};
</script>
